import script from "./Collection.vue?vue&type=script&setup=true&lang=js"
export * from "./Collection.vue?vue&type=script&setup=true&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=3bdc2fe6&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdc2fe6"]])

export default __exports__